import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionType, FrequencyType } from './AddTransactionFlow';
import { Icon } from '../Icon';
import './TitleInput.css';

interface TitleInputProps {
  value: string;
  transactionType: TransactionType;
  frequency: FrequencyType;
  onChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}

// Подсказки в зависимости от типа транзакции
const expenseSuggestions = [
  'Продукты', 'Коммунальные услуги', 'Транспорт', 'Кофе',
  'Аренда', 'Мобильная связь', 'Развлечения', 'Одежда',
  'Здоровье', 'Образование', 'Рестораны', 'Фитнес'
];

const incomeSuggestions = [
  'Зарплата', 'Премия', 'Подарок', 'Подработка',
  'Возврат', 'Приз', 'Инвестиции', 'Фриланс'
];

export const TitleInput: React.FC<TitleInputProps> = ({
  value,
  transactionType,
  frequency,
  onChange,
  onNext,
  onBack
}) => {
  const { t } = useTranslation();
  const [showSuggestions, setShowSuggestions] = useState(true);
  const suggestions = transactionType === 'expense' ? expenseSuggestions : incomeSuggestions;

  const frequencyLabels: Record<FrequencyType, string> = {
    onetime: t('transaction.frequency.onetime'),
    daily: t('transaction.frequency.daily'),
    weekly: t('transaction.frequency.weekly'),
    monthly: t('transaction.frequency.monthly'),
    yearly: t('transaction.frequency.yearly')
  };

  const typeLabel = transactionType === 'expense' ? t('transaction.expense') : t('transaction.income');

  const handleSubmit = () => {
    if (value.trim()) {
      onNext();
    }
  };

  return (
    <div className="title-input step-content">
      <div className="title-input__header">
        <button className="title-input__back neo-raised" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="title-input__header-content">
          <h2 className="title-input__title">{t('transaction.title')}</h2>
          <p className="title-input__subtitle">
            {frequencyLabels[frequency]} {typeLabel}
          </p>
        </div>
      </div>

      <div className="title-input__input-wrapper">
        <input
          type="text"
          className="title-input__input neo-inset"
          placeholder={transactionType === 'expense' ? t('transaction.titlePlaceholderExpense') : t('transaction.titlePlaceholderIncome')}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setShowSuggestions(e.target.value.length === 0);
          }}
          onFocus={() => setShowSuggestions(value.length === 0)}
          onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
        />
        {value && (
          <button
            className="title-input__clear neo-raised"
            onClick={() => {
              onChange('');
              setShowSuggestions(true);
            }}
          >
            ✕
          </button>
        )}
      </div>

      {showSuggestions && (
        <div className="title-input__suggestions">
          <div className="title-input__suggestions-title">{t('transaction.popularSuggestions')}:</div>
          <div className="title-input__suggestions-grid">
            {suggestions.map((suggestion) => (
              <button
                key={suggestion}
                className="title-suggestion"
                onClick={() => {
                  onChange(suggestion);
                  setShowSuggestions(false);
                }}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}

      <button
        className="title-input__next neo-raised"
        onClick={handleSubmit}
        disabled={!value.trim()}
      >
        {t('common.next')}
      </button>
    </div>
  );
};

